import { AWARD_LIST, AWARD_WOP_LIST, AWARD_CHANGE_STATUS, AWARD_ADDEDIT, AWARD_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const awardListApi = (payload) => {
    return apiInstance.post(AWARD_LIST, payload, {
        headers: authHeader(),
    });
};

export const awardChangeStatusApi = (payload) => {
    return apiInstance.post(AWARD_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditAwardApi = (payload) => {
    return apiInstance.post(AWARD_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const awardWopListApi = (payload) => {
    return apiInstance.get(AWARD_WOP_LIST, {
        headers: authHeader(),
        params: payload
    });
};

export const awardDeleteApi = (payload) => {
    return apiInstance.post(AWARD_DELETE, payload, {
        headers: authHeader(),
    });
};